/**
 * Epic Analytics Filters Component
 * 
 * Filter controls for project and date range selection
 * in the Epic Analytics Dashboard. Uses the shared component
 * for consistency with the Epic Analysis page.
 */

import React, { memo } from 'react'
import SharedEpicFilters from '../SharedEpicFilters'
import { XProject } from '@jirax/common'

interface DateRange {
  startDate: string
  endDate: string
}

interface EpicAnalyticsFiltersProps {
  selectedProject: XProject | null
  dateRange: DateRange
  projects: XProject[]
  onProjectChange: (project: XProject) => void
  onDateRangeChange: (range: DateRange) => void
  loading?: boolean
  disabled?: boolean
}

/**
 * Epic Analytics Filters - Project and date range selection controls
 * Uses the shared component for consistency with Epic Analysis
 */
const EpicAnalyticsFilters: React.FC<EpicAnalyticsFiltersProps> = memo((props) => {
  return (
    <SharedEpicFilters
      {...props}
      cardClassName="p-6 mb-6 overflow-visible"
      ariaLabelledBy="epic-analytics-filters-heading"

    />
  )
})

EpicAnalyticsFilters.displayName = 'EpicAnalyticsFilters'

export { EpicAnalyticsFilters }
export default EpicAnalyticsFilters